<template>
  <div>
    <Navbar :toReset="(url) => this.reset(url)" />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rekam Medis" :toReset="(url) => this.reset(url)" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <!-- <form> -->
          <div class="row mb-5">
            <div class="col-md-6">
              <h5 class="text-uppercase text-info mb-3">data pasien</h5>
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
            <div class="col-md-6">
              <h5 class="text-uppercase text-info mb-3">
                data penanggung jawab
              </h5>
              <FormRow
                v-for="row in rightForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <h5 class="text-uppercase text-info mb-3">data pembayaran</h5>
              <FormRow
                v-for="row in rightFormBottom"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  type="submit"
                  @click="handleForm"
                  class="btn btn-primary btn-with-icon-left float-right text-uppercase ml-3"
                >
                  <i class="material-symbols-outlined">check</i>
                  Simpan Data Pasien
                </button>
                <!-- <router-link
                  class="btn btn-outline-danger btn-no-outline float-right"
                  to="/pasien"
                  >Batalkan</router-link
                > -->
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => goBack('/pasien')"
                  >Batalkan
                </a>
              </div>
            </div>
          </div>
          <!-- </form> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
// import FormGroup from "@/components/FormGroup.vue";
import FormData from "form-data";
// import { HTTP } from "@/config.js";
import { leftForm, rightForm, rightFormBottom } from "@/data/PasienForm.js";
import { resetForms } from "@/data/helper.js";
import { regexErrors, regexes, regexPlaceholders } from "@/data/helper.js";
let data = {
  title: "Ubah Data Pasien",
  backBtn: "/pasien/detail/",
  actionBtn: [],
  breadcrumb: [
    { title: "Pasien", link: "/pasien" },
    { title: "Ubah Data Pasien", active: true },
  ],
};

export default {
  name: "PasienFormEdit",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    // FormGroup
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      leftForm: leftForm,
      rightForm: rightForm,
      rightFormBottom: rightFormBottom,
      fotoLama: "",
      validated: false,
      formSet: {
        // id_faskes:"",
        no_rm: "",
        id_provinsi: "",
        id_kota: "",
        id_kecamatan: "",
        id_kelurahan: "",
        id_provinsi_pj: "",
        id_kota_pj: "",
        id_kecamatan_pj: "",
        id_kelurahan_pj: "",
        id_asuransi: "",
        nama: "",
        jen_kelamin: "",
        gol_darah: "",
        tmp_lahir: "",
        tgl_lahir: "",
        pendidikan: "",
        nama_ibu: "",
        agama: "",
        status_nikah: "",
        no_telp: "",
        pekerjaan: "",
        jenis_id: "",
        no_id: "",
        alamat: "",
        pj_jenis: "",
        pj_nama: "",
        pj_pekerjaan: "",
        pj_alamat: "",
        asuransi_lain: "",
        no_peserta: "",
        foto: null,
        suku: "",
        email: "",
      },
    };
  },
  methods: {
    goBack(url) {
      // //console.log(this.fromUrl);
      resetForms(
        this.formSet,
        [this.leftForm, this.paymentForm, this.referenceForm],
        true,
        this.handleChange
      );
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    handleForm: async function() {
      ////console.log(this.formSet.no_rm);
      this.errors = [];
      let formData = new FormData();
      var self = this;
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          if (self.formSet[key]) {
            if (!(key == "foto" && self.formSet[key] == self.fotoLama)) {
              formData.append(key, self.formSet[key]);
            }
          }
        });
        ////console.log(this.formSet);
        try {
          let result = await this.$store.state.HTTP.post(
            "pasien/" + this.$route.params.id,
            formData
          );
          ////console.log(result);
          if (result.status == "200") {
            this.$store.state.HTTP_SIAKUN.post("kontak/tambah-simrs", {
              nama: this.formSet.nama,
              nomorTelepon: this.formSet.no_telp,
              kodeKontak: this.formSet.no_rm,
              isPelanggan: "1",
              isPemasok: "0",
              isKaryawan: "0",
            });
            ////console.log(resultSiakun);
            this.validated = false;
            this.$router.push(`/pasien/detail/${this.$route.params.id}`);
          } else {
            ////console.log(result.status);
            this.errors.push(result.status);
          }
        } catch (e) {
          ////console.log(e);
          this.errors.push(e);
        }
      } else {
        ////console.log("tidak valid");
      }
    },
    reset(url, stay) {
      resetForms(
        this.formSet,
        [this.leftForm, this.rightForm, this.rightFormBottom],
        true,
        this.handleChange
      );
      if (!url) {
        this.$router.go(-1);
      } else {
        ////console.log(url);
        this.$router.push(url);
      }
    },
    handleChange(e, initial) {
      ////console.log(e);
      if (e.target.type == "file") {
        ////console.log(e.target.files);
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
      }

      if (e.target.name == "id_provinsi" || e.target.name == "id_provinsi_pj") {
        let cities =
          e.target.name == "id_provinsi"
            ? this.leftForm[9].columns[1]
            : this.rightForm[4].columns[1];
        this.fetchCities(e.target.value, cities);
      } else if (e.target.name == "id_kota" || e.target.name == "id_kota_pj") {
        let districts =
          e.target.name == "id_kota"
            ? this.leftForm[10].columns[0]
            : this.rightForm[5].columns[0];
        this.fetchDistricts(e.target.value, districts);
      } else if (
        e.target.name == "id_kecamatan" ||
        e.target.name == "id_kecamatan_pj"
      ) {
        let subdistricts =
          e.target.name == "id_kecamatan"
            ? this.leftForm[10].columns[1]
            : this.rightForm[5].columns[1];
        this.fetchSubdistricts(e.target.value, subdistricts);
      } else if (e.target.name == "id_asuransi") {
        // Jika yang dipilih adalah Metode Pembayaran Umum
        if (e.target.value == 1) {
          // Hide kolom Pilih Asuransi
          this.rightFormBottom[1].columns[0].type = "hidden";
          // Hide Kolom Nomor Peserta
          this.rightFormBottom[2].columns[0].type = "hidden";
          // Reset Regex pada Kolom Nomor Peserta
          this.rightFormBottom[2].columns[0].regex = "";
          this.rightFormBottom[2].columns[0].placeholder = "";
          this.rightFormBottom[2].columns[0].regexError = "";
          // Hide Kolom Asal Faskes
          this.rightFormBottom[3].columns[0].type = "hidden";
          // Reset nilai kolom Pilih Asuransi
          this.formSet["asuransi_lain"] = "";
          // Reset nilai kolom Nomor Peserta
          if (!initial) {
            this.formSet["no_peserta"] = "";
          }
          // Reset nilai kolom Asal Faskes
          this.formSet["asal_faskes"] = "";
        }
        // Jika yang dipilih adalah Metode Pembayaran BPJS
        else if (e.target.value == 2) {
          // Hide kolom Pilih Asuransi
          this.rightFormBottom[1].columns[0].type = "hidden";
          // Show kolom Nomor Peserta
          this.rightFormBottom[2].columns[0].type = "text";
          this.rightFormBottom[2].columns[0].mandatory = true;
          this.rightFormBottom[2].columns[0].optional = false;
          // Set Regex pada Kolom Nomor Peserta
          this.rightFormBottom[2].columns[0].regex = regexes.BPJS;
          this.rightFormBottom[2].columns[0].placeholder =
            regexPlaceholders.BPJS;
          this.rightFormBottom[2].columns[0].regexError = regexErrors.BPJS;
          // Show Kolom Asal Faskes
          this.rightFormBottom[3].columns[0].type = "select";
          // Reset nilai kolom Pilih Asuransi
          this.formSet["asuransi_lain"] = "";
          // Reset nilai kolom Nomor Peserta
          if (!initial) {
            this.formSet["no_peserta"] = "";
          }
        }
        // Jika yang dipilih adalah Metode Pembayaran Asuransi Lain
        else if (e.target.value == 3) {
          // Show kolom Pilih Asuransi
          this.rightFormBottom[1].columns[0].type = "select";
          // Show kolom nomor peserta
          this.rightFormBottom[2].columns[0].type = "text";
          this.rightFormBottom[2].columns[0].mandatory = false;
          this.rightFormBottom[2].columns[0].optional = true;
          // Reset Regex pada Kolom Nomor Peserta
          this.rightFormBottom[2].columns[0].regex = "";
          this.rightFormBottom[2].columns[0].placeholder = "";
          this.rightFormBottom[2].columns[0].regexError = "";
          // Hide kolom asal faskes
          this.rightFormBottom[3].columns[0].type = "hidden";
          // Reset nilai Kolom asal faskes
          this.formSet["asal_faskes"] = "";
          // Reset nilai kolom Nomor Peserta
          if (!initial) {
            this.formSet["no_peserta"] = "";
          }
        }
        if (this.validated) {
          this.validateForm();
        }
        // this.rightFormBottom.splice(1,1,this.rightFormBottom[1]);
      } else if (e.target.name == "jenis_id") {
        // Set Regex pada Kolom Nomor Identitas
        this.leftForm[7].columns[1].value = "";
        this.leftForm[7].columns[1].label = "Nomor " + e.target.value;
        this.leftForm[7].columns[1].regex = regexes[e.target.value];
        this.leftForm[7].columns[1].placeholder =
          regexPlaceholders[e.target.value];
        this.leftForm[7].columns[1].regexError = regexErrors[e.target.value];
        // Reset nilai kolom Nomor Identitas
        if (!initial) {
          this.formSet["no_id"] = "";
          if (this.validated) {
            this.validateForm();
          }
        }

        // this.leftForm[7].columns.splice(1,1,this.leftForm[7].columns[1]);
      }
      // else if (e.target.name == "id_asuransi") {
      //   if (e.target.value == 1) {
      //     this.rightFormBottom[1].columns[0].type = "hidden";
      //     this.rightFormBottom[2].columns[0].type = "hidden";
      //     this.rightFormBottom[3].columns[0].type = "hidden";
      //     this.formSet["asuransi_lain"] = "";
      //     this.formSet["no_peserta"] = "";
      //     // this.formSet["id_faskes"] = "";
      //   } else if (e.target.value == 2) {
      //     this.rightFormBottom[1].columns[0].type = "hidden";
      //     this.rightFormBottom[2].columns[0].type = "text";
      //     this.rightFormBottom[3].columns[0].type = "select";
      //     this.formSet["asuransi_lain"] = "";
      //   } else if (e.target.value == 3) {
      //     this.rightFormBottom[1].columns[0].type = "select";
      //     this.rightFormBottom[2].columns[0].type = "text";
      //     this.rightFormBottom[3].columns[0].type = "hidden";
      //     // this.formSet["id_faskes"] = "";
      //   }
      // }
    },
    fetchProvinces: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "wilayah/provinsi?per_page=9999999999"
        );
        if (result.status == "200") {
          ////console.log(result);
          let provinces = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
          this.leftForm[9].columns[0].options = provinces;
          this.rightForm[4].columns[0].options = provinces;
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchFaskes: async function() {
      ////console.log('Masuk Fetch Faskes');
      try {
        let result = await this.$store.state.HTTP.get(
          "faskes?per_page=9999999999"
        );
        ////console.log(result);
        if (result.status == "200") {
          let faskes = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
          this.rightFormBottom[3].columns[0].options = faskes;
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchCities: async function(id, city, initial) {
      try {
        let result = await this.$store.state.HTTP.get(
          `wilayah/kota?id_provinsi=${id}&per_page=9999999999`
        );
        if (result.status == "200") {
          ////console.log(result);
          city.value = String(this.formSet[city.name]);
          city.options = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
          if (initial) {
            this.leftForm.splice(9, 1, this.leftForm[9]);
            this.rightForm.splice(4, 1, this.rightForm[4]);
          }
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchDistricts: async function(id, district, initial) {
      try {
        let result = await this.$store.state.HTTP.get(
          `wilayah/kecamatan?id_kota=${id}&per_page=9999999999`
        );
        if (result.status == "200") {
          ////console.log(result);
          district.options = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
          if (initial) {
            this.leftForm.splice(10, 1, this.leftForm[10]);
            this.rightForm.splice(5, 1, this.rightForm[5]);
          }
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchSubdistricts: async function(id, subdistrict, initial) {
      try {
        let result = await this.$store.state.HTTP.get(
          `wilayah/kelurahan?id_kecamatan=${id}&per_page=9999999999`
        );
        if (result.status == "200") {
          ////console.log(result);
          subdistrict.options = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
          if (initial) {
            this.leftForm.splice(10, 1, this.leftForm[10]);
            this.rightForm.splice(5, 1, this.rightForm[5]);
          }
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    fetchAsuransi: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "asuransi_lain?per_page=9999999999"
        );
        ////console.log(result);
        if (result.status == "200") {
          ////console.log(result.data);
          let items = result.data.data;
          ////console.log(items);
          this.rightFormBottom[1].columns[0].options = items.map(function(
            item
          ) {
            item.label = `${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        ////console.log(e);
      }
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      ////console.log(self.formSet);
      this.leftForm = this.leftForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            //console.log(column);
            if (column.regex) {
              if (String(self.formSet[column.name] || "").match(column.regex)) {
                //console.log(self.formSet[column.name])
                column.error = "";
              } else {
                column.error = column.regexError;
                valid = false;
              }
            } else {
              column.error = "";
            }
          }
          column.value = self.formSet[column.name];

          return column;
        });
        return row;
      });
      this.rightForm = this.rightForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            //console.log(column);
            if (column.regex) {
              //console.log(column.regex);
              if (String(self.formSet[column.name] || "").match(column.regex)) {
                column.error = "";
              } else {
                column.error = column.regexError;
                valid = false;
              }
            } else {
              column.error = "";
            }
          }

          column.value = self.formSet[column.name];
          return column;
        });
        return row;
      });
      this.rightFormBottom = this.rightFormBottom.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            //console.log(column);
            if (column.regex) {
              //console.log(column.regex);
              if (String(self.formSet[column.name] || "").match(column.regex)) {
                column.error = "";
              } else {
                column.error = column.regexError;
                valid = false;
              }
            } else {
              column.error = "";
            }
          }
          if (column.name == "foto") {
            if (self.formSet[column.name] != self.fotoLama) {
              ////console.log(self.formSet[column.name]);
              var reader = new FileReader();
              reader.onload = function(e) {
                column.value = e.target.result;
                // column.key=Math.random();
                self.rightFormBottom.map((item) => {
                  item.columns = item.columns.map((column) => {
                    return column;
                  });
                  return item;
                });
              };
              reader.readAsDataURL(self.formSet[column.name]);
            } else {
              self.formSet[column.name];
              ////console.log(column.value);
              ////console.log(self.fotoLama);
            }
          } else {
            column.value = self.formSet[column.name];
          }
          return column;
        });
        return row;
      });
      setTimeout(function() {
        // ////console.log('berhasil masuk ke awal sini');
        // self.rightFormBottom.map((item)=>{ item.columns=item.columns.map((column)=>{column.key=Math.random();return column;});return item;});
        // ////console.log('berhasil masuk ke akhir sini');
      }, 2000);
      this.validated = true;
      return valid;
    },
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `pasien/${this.$route.params.id}?darurat=0`
        );
        //console.log(result);
        if (result.status == "200") {
          let pasien = result.data;
          ////console.log(pasien);
          // this.formSet=pasien;
          let self = this;
          Object.keys(this.formSet).forEach(function(key) {
            if (key == "foto") {
              self.formSet[key] = pasien["formatted_foto"];
              self.fotoLama = pasien["formatted_foto"];
            } else {
              self.formSet[key] = pasien[key];
            }
          });

          this.updateForm();
          ////console.log(pasien);
        } else {
          ////console.log(result.status);
          this.errors.push(result.status);
        }
      } catch (e) {
        ////console.log(e);
        this.errors.push(e);
      }
    },
    updateForm() {
      let self = this;
      let forms = [this.leftForm, this.rightForm, this.rightFormBottom].map(
        function(form) {
          form = form.map(function(row) {
            row.columns = row.columns.map(function(column) {
              if (self.formSet[column.name]) {
                column.value = self.formSet[column.name];
                if (
                  ["id_asuransi", "jenis_id", "no_id", "no_peserta"].indexOf(
                    column.name
                  ) > -1
                ) {
                  self.handleChange(
                    {
                      target: {
                        value: self.formSet[column.name],
                        name: column.name,
                        type: column.type,
                      },
                    },
                    true
                  );
                }
              }
              return column;
            });
            return row;
          });
          return form;
        }
      );
      this.leftForm = forms[0];
      this.rightForm = forms[1];
      this.rightFormBottom = forms[2];
      this.fetchCities(
        String(this.formSet.id_provinsi),
        this.leftForm[9].columns[1],
        true
      );
      this.fetchCities(
        String(this.formSet.id_provinsi_pj),
        this.rightForm[4].columns[1],
        true
      );
      this.fetchDistricts(
        String(this.formSet.id_kota),
        this.leftForm[10].columns[0],
        true
      );
      this.fetchDistricts(
        String(this.formSet.id_kota_pj),
        this.rightForm[5].columns[0],
        true
      );
      this.fetchSubdistricts(
        String(this.formSet.id_kecamatan),
        this.leftForm[10].columns[1],
        true
      );
      this.fetchSubdistricts(
        String(this.formSet.id_kecamatan_pj),
        this.rightForm[5].columns[1],
        true
      );

      ////console.log(leftForm)
      ////console.log(rightForm)
    },
  },

  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.fetchProvinces();
    this.fetchFaskes();
    this.fetchAsuransi();
    this.displayData();
    this.rightFormBottom[3].columns[0].refresh = this.fetchFaskes;
    this.rightFormBottom.splice(3, 1, this.rightFormBottom[3]);
  },
};
</script>
